// extracted by mini-css-extract-plugin
export default {"title":"Quote_title__wbeGu","subTitle":"Quote_subTitle__PA4Kp","license":"Quote_license__-46LC","details":"Quote_details__qFOXH","contactBtn":"Quote_contactBtn__J+8wc"};